import React from "react";
import PropTypes from "prop-types";
import createReactClass from "create-react-class";

export default createReactClass({
  displayName: "Root",
  propTypes: {
    albumId: PropTypes.number.isRequired,
    isActive: PropTypes.bool.isRequired,
    albumSelected: PropTypes.func.isRequired,
  },
  getInitialState() {
    return {
      isShaking: false,
    };
  },
  componentDidMount() {
    var delay = Math.random() * 1000;
    setTimeout(
      function() {
        this.setState({
          isShaking: true,
        });
      }.bind(this),
      delay
    );
  },
  handleAlbumDeleteButton() {
    this.props.albumSelected(this.props.albumId);
  },
  render() {
    if (this.props.isActive) {
      return (
        <div
          className={
            "delete-photo-button" + (this.state.isShaking ? " shake" : "")
          }
          onClick={this.handleAlbumDeleteButton}
        >
          <strong>×</strong>
        </div>
      );
    } else {
      return (
        <div
          className={
            "delete-photo-button" + (this.state.isShaking ? " shake" : "")
          }
        />
      );
    }
  },
});
